import { listCheckboxAtributos } from './atributosHallazgos';

export const searchAtributos = (atributosParams) => {
  try {
    if (atributosParams) {
      const arrayAtributos = atributosParams?.split(',').map(Number);
      const labels = listCheckboxAtributos
        .filter((item) => arrayAtributos?.includes(item.value))
        .map((item) => item.label);
      /** Devuelve la lista de nombre del hallazgo que traen desde "atributos" */
      return labels;
    }
    return [];
  } catch (error) {
    console.log('Error al generar la lista de nombres de tipos de hallazgos.', error);
    return [];
  }
};
